// Rename this to generic fetchDocs 

import { useQuery } from "react-query";
import { setHeaders } from "../../../utils/basic";
import * as config from "../../../app.config";
import axios from "axios";

const getDocumentData = async (doc) => {
    const headerConfig = setHeaders();
    const { data } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/display/documentation/${doc}`,
        {
            headers: headerConfig
        }
    );
    return data?.signedUrl;
}

export const useFetchHelpDoc = (doc) => {
    return useQuery(["getDoc", doc], () => getDocumentData(doc), {
        onSuccess: (data) => {
            //console.log({ data });
        },
        onError: (error) => {
            console.log({ error });
        }
    });
}